import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { createSelector } from 'reselect';
import {
  upperFirst,
  isEmpty,
  filter,
  toLower,
  map,
  remove,
  find,
  forEach,
  get,
} from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import {
  Button,
  Card,
  Modal,
  IconButton,
  Paper,
  Typography,
  Grid,
  Tabs,
  Tab,
  Input,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@material-ui/core';
import {
  Search,
  AccountCircle,
  HighlightOff,
  AddCircle,
} from '@material-ui/icons';

import { HeaderTable, PaperHeader } from '../../app/components';
import { fetchStudents } from '../students/actions';
import { fetchUser } from '../auth/actions';
import {
  addSubsidyStudents,
  removeSubsidyStudents,
  distributeSubsidyCredits,
  studentSubsidyReject,
  studentSubsidyApprove,
  fetchSubsidizedStudents,
  subscribeToSubsidy,
} from '../subsidy/actions';
import { getMoment } from '../../util/dates';
import { loadTexts } from '../../config/texts';
const TEXT_KEY = "program";

class Program extends React.Component {
  state = {
    selectedHeader: 0,
    anchorEl: null,
    search: '',
    openDialog: false,
    applyAllCredits: 0,
    searchAllStudent: '',
    showAddStudentModal: false,
    showManageCredits: false,
    selectedStudents: [],
    selectedApplicants: [],
    studentsToAdd: [],
    confirmRemove: false,
    selectedAction: '',
    org: find(
      this.props.organizations,
      o => o._id === this.props.selectedOrganization,
    ),
    texts: loadTexts(TEXT_KEY, this.props.locale),
  };

  componentDidMount() {
    this._subscription = subscribeToSubsidy({
      organizationIds: this.props.organizations.map(o => o._id),
    });
    this._subscription.subscribe(() => {
      this.fetchSubsidizedStudents();
    });
    if (isEmpty(this.props.students)) this.fetchSubsidizedStudents();
    /*
      this.props.fetchStudents({
        studentSearchInput: {
          _universities: [this.props.selectedUniversity],
          _organizations: [this.props.selectedOrganization],
        },
      });
      */
  }

  componentWillReceiveProps(nextProps) {
    //const { program, organization } = this.props.location.state;
  }

  componentWillUnmount() {
    if (this._subscription) this._subscription.unsubscribe();
  }

  fetchSubsidizedStudents = () => {
    /*
    this.props.fetchSubsidizedStudents({
      organization: this.props.selectedOrganization,
    });
    */
    this.props.fetchStudents({
      studentSearchInput: {
        _universities: [this.props.selectedUniversity],
        _organizations: [this.props.selectedOrganization],
      },
    });
  };

  _onCloseDialog() {
    this.setState({ openDialog: false });
  }

  onCheckRow(d) {
    const { selectedStudents, selectedHeader, selectedApplicants } = this.state;
    let temp = selectedHeader === 0 ? selectedStudents : selectedApplicants;
    if (!isEmpty(find(temp, i => i._id == d._id))) {
      remove(temp, i => i._id == d._id);
    } else {
      temp.push(d);
    }
    if (selectedHeader === 0) this.setState({ selectedStudents: temp });
    else this.setState({ selectedApplicants: temp });
  }

  onCloseMenu() {
    this.setState({ anchorEl: null });
  }

  onRemoveStudent(s) {
    const { studentsToAdd } = this.state;
    let temp = studentsToAdd;
    remove(temp, student => student.user._id === s.user._id);
    this.setState({ studentsToAdd: temp });
  }

  onAddStudent(s) {
    const { studentsToAdd } = this.state;
    let temp = studentsToAdd;
    const included = find(
      studentsToAdd,
      student => student.user._id === s.user._id,
    );

    if (isEmpty(included)) {
      this.setState({ searchAllStudent: '' });
      return temp.push(s);
    } else {
      this.setState({ searchAllStudent: '' });
    }
  }

  renderRemoveModal() {
    const { confirmRemove, selectedStudents, texts } = this.state;
    const { classes } = this.props;
    const { program } = this.props.location.state;
    const students = map(selectedStudents, s => s._id);

    return (
      <Modal
        open={confirmRemove}
        onClose={() => this.setState({ confirmRemove: false })}
      >
        <Card className={classes.confirmRemoveModal}>
          <Grid
            container
            direction="column"
            justify="space-between"
            alignItems="center"
          >
            <Typography variant="primary" style={{ marginBottom: 20 }}>
              {texts.alert.remove_student}
            </Typography>
          </Grid>
          <Grid
            direction="row"
            justify="space-between"
            alignItems="flex-end"
            style={{ width: '100%' }}
          >
            <Button
              variant="contained"
              size="small"
              color="primary"
              style={{ marginRight: 10 }}
              onClick={() => this.setState({ confirmRemove: false })}
            >
              {texts.alert.button_text.cancel}
            </Button>
            <Button
              variant="contained"
              size="small"
              color="primary"
              style={{ marginRight: 10 }}
              onClick={async () => {
                await this.props.removeSubsidyStudents({
                  subsidy: program._id,
                  students,
                });
                await this.fetchSubsidizedStudents();
                /*
                await this.props.fetchStudents({
                  studentSearchInput: {
                    _universities: [this.props.selectedUniversity],
                    _organizations: [this.props.selectedOrganization],
                  },
                });
                */
                this.setState({
                  studentsToAdd: [],
                  searchAllStudent: '',
                  selectedApplicants: [],
                  confirmRemove: false,
                });
              }}
            >
              {texts.alert.button_text.confirm}
            </Button>
          </Grid>
        </Card>
      </Modal>
    );
  }

  reformatData(d, type) {
    const { program } = this.props.location.state;
    const { texts: { fields } } = this.state;
    return map(d, s => {
      const prog = find(s.subsidyCredits, c => c.subsidyId === program._id);
      if (type === 'approved')
        return {
          _id: s._id,
          [fields.name]: `${s.user.first} ${s.user.last}`,
          [fields.email]: s.user.email,
          [fields.current_credits]: (prog.credits / 100).toFixed(2),
          [fields.credits_used]: (prog.creditsSpent / 100).toFixed(2),
          [fields.date_approved]:
            getMoment(prog.approvedAt.timestamp).format('YYYY-MM-DD') || '',
        };
      else
        return {
          _id: s._id,
          [fields.name]: `${s.user.first} ${s.user.last}`,
          [fields.email]: s.user.email,
          [fields.date_requested]:
            getMoment(prog.requestedAt.timestamp).format('YYYY-MM-DD') || '',
        };
    });
  }

  renderProgramCredits() {
    const { classes, organizations, selectedOrganization } = this.props;
    const { program } = this.props.location.state;
    const org = find(organizations, o => o._id === selectedOrganization);
    const { texts: { titles } } = this.state;
    return (
      <Grid item>
        <Grid container className={classes.gridContainer}>
          <Grid item>
            <Typography
              variant="subheading"
              color="inherit"
              className={classes.padding}
            >
              {titles.total_credits}
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="subheading" className={classes.green}>
              {(this.state.org.credits / 100).toFixed(2)}
            </Typography>
          </Grid>
        </Grid>
        <Grid container className={classes.gridContainer}>
          <Typography variant="subheading" className={classes.padding}>
            {titles.credits_distributed}
          </Typography>
          <Typography variant="subheading">
            {(program.creditsDistributed / 100).toFixed(2)}
          </Typography>
        </Grid>
        <Grid container className={classes.gridContainer}>
          <Typography variant="subheading" className={classes.padding}>
            {titles.credits_used}
          </Typography>
          <Typography variant="subheading" style={{ color: 'red' }}>
            {(program.creditsUsed / 100).toFixed(2)}
          </Typography>
        </Grid>
      </Grid>
    );
  }

  renderHeader() {
    const { selectedHeader, texts: { titles } } = this.state;
    const { classes } = this.props;

    return (
      <Tabs
        value={selectedHeader}
        onChange={(event, value) => {
          this.setState({ selectedHeader: value });
          if (value === 0) this.setState({ selectedApplicants: [] });
          else this.setState({ selectedStudents: [] });
        }}
        classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator }}
      >
        <Tab
          disableRipple
          label={<div className={classes.tabText}>{titles.approved}</div>}
          classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
        />
        <Tab
          disableRipple
          label={<div className={classes.tabText}>{titles.application}</div>}
          classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
        />
      </Tabs>
    );
  }

  async continueAction() {
     const { selectedAction, selectedApplicants } = this.state;
     const { program } = this.props.location.state;
     const applicantsArray = map(selectedApplicants, a => a._id);

     if (selectedAction === 'approve') {
       await this.props.studentSubsidyApprove({
         subsidy: program._id,
         students: applicantsArray,
       });
       await this.fetchSubsidizedStudents();
       /*
       await this.props.fetchStudents({
         studentSearchInput: {
           _universities: [this.props.selectedUniversity],
           _organizations: [this.props.selectedOrganization],
         },
       });
       */
       this.setState({
         studentsToAdd: [],
         searchAllStudent: '',
         selectedApplicants: [],
         openDialog: false,
       });
     } else {
       await this.props.studentSubsidyReject({
         subsidy: program._id,
         students: applicantsArray,
       });
       await this.fetchSubsidizedStudents();
       /*
       await this.props.fetchStudents({
         studentSearchInput: {
           _universities: [this.props.selectedUniversity],
           _organizations: [this.props.selectedOrganization],
         },
       });
       */
       this.setState({
         showAddStudentModal: false,
         studentsToAdd: [],
         searchAllStudent: '',
         selectedApplicants: [],
         openDialog: false,
       });
     }
  }

  renderActions() {
    const { classes } = this.props;

    return (
      <div className={classes.actionContainer}>
        {this.renderSearch()}
        {this.renderStudentButtons()}
      </div>
    );
  }

  renderStudentButtons() {
    const {
      selectedHeader,
      anchorEl,
      selectedStudents,
      selectedApplicants,
      texts: { button_text },
    } = this.state;
    const { program } = this.props.location.state;
    const applicantsArray = map(selectedApplicants, a => a._id);
    return (
      <div style={{ flexDirection: 'row', display: 'flex' }}>
        {selectedHeader === 0 && (
          <Button
            variant="contained"
            size="small"
            color="primary"
            style={{ marginRight: 10 }}
            onClick={() => this.setState({ showAddStudentModal: true })}
          >
            {`+ ${button_text.add}`}
          </Button>
        )}
        <div>
          <Button
            variant="contained"
            size="small"
            color="primary"
            aria-owns={anchorEl ? 'simple-menu' : null}
            aria-haspopup="true"
            onClick={e => {
              this.setState({ anchorEl: e.currentTarget });
            }}
          >
            {button_text.action}
          </Button>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => this.onCloseMenu()}
          >
            <MenuItem
              onClick={async () => {
                if (selectedHeader === 0) {
                  this.setState({ showManageCredits: true });
                } else {
                  this.setState({ openDialog: true, selectedAction: 'approve' });
                }
                this.onCloseMenu();
              }}
            >
              {selectedHeader === 0 ? button_text.manage_credits : button_text.approve}
            </MenuItem>
            <MenuItem
              disabled={selectedHeader === 0 && isEmpty(selectedStudents)}
              onClick={async () => {
                this.onCloseMenu();
                const students = await map(selectedStudents, s => s._id);
                if (selectedHeader === 0) {
                  this.setState({ confirmRemove: true });
                } else {
                  this.setState({ openDialog: true, selectedAction: 'remove' });
                }
              }}
            >
              {selectedHeader === 0 ? button_text.remove : button_text.deny}
            </MenuItem>
          </Menu>
        </div>
      </div>
    );
  }

  renderSearch() {
    const { classes } = this.props;

    return (
      <div className={classes.searchContainer}>
        <Search style={{ marginRight: 5, color: '#4153af' }} />
        <Input
          value={this.state.search}
          disableUnderline
          fullWidth
          onChange={event => this.setState({ search: event.target.value })}
          style={{ color: '#4153af' }}
        />
      </div>
    );
  }

  renderSearchStudentsResult() {
    const { searchAllStudent } = this.state;
    const { classes, students } = this.props;
    const { program } = this.props.location.state;

    const approved = filter(
      students,
      s =>
        !isEmpty(
          find(s.subsidyCredits, c => {
            if (!isEmpty(c))
              return c.subsidyId === program._id && c.status === 'approved';
            else return false;
          }),
        ),
    );
    const approvedIds = map(approved, a => a._id);
    const allButApproved = filter(students, s => !approvedIds.includes(s._id));

    const filteredData = filter(allButApproved, s => {
      const full = `${s.user.first} ${s.user.last}`;
      return toLower(full).includes(toLower(searchAllStudent));
    });

    if (!isEmpty(searchAllStudent))
      return (
        <Card className={classes.searchStudentContainer}>
          {map(filteredData, s => (
            <div className={classes.addedStudentsContainer}>
              <Typography>{`${s.user.first} ${s.user.last}`}</Typography>
              <IconButton onClick={() => this.onAddStudent(s)}>
                <AddCircle color="inherit" style={{ color: '#4153af' }} />
              </IconButton>
            </div>
          ))}
        </Card>
      );
  }

  renderMangeCreditsTitle() {
    const { classes } = this.props;
    const { organization } = this.props.location.state;
    const { selectedStudents, texts: { titles } } = this.state;
    let creditsToAdd = 0;
    forEach(selectedStudents, s => {
      if (s.add_amount) {
        creditsToAdd = creditsToAdd + parseInt(s.add_amount);
      }
    });

    const remainCredits = organization.credits - creditsToAdd * 100;
    return (
      <div className={classes.addedStudentsContainer}>
        <Typography
          variant="body2"
          style={{ fontWeight: '800', marginBottom: 10 }}
        >
          {titles.distribute}
        </Typography>
        <div className={classes.addedStudentsContainer}>
          <Typography variant="body2" style={{ marginRight: 10 }}>
            {`${titles.remain}:`}
          </Typography>
          <Typography
            variant="body2"
            style={{ color: remainCredits < 0 ? 'red' : 'green' }}
          >
            {(remainCredits / 100).toFixed(2)}
          </Typography>
        </div>
      </div>
    );
  }

  renderApplyAll() {
    const { classes } = this.props;
    const { applyAllCredits, selectedStudents, texts } = this.state;

    return (
      <div
        style={{
          flexDirection: 'row',
          display: 'flex',
          alignItems: 'center',
          width: '50%',
        }}
      >
        <Input
          value={applyAllCredits}
          disableUnderline
          fullWidth
          onChange={event =>
            this.setState({ applyAllCredits: Math.abs(event.target.value) })
          }
          className={classes.applyAllInput}
          type="number"
        />
        <Button
          variant="contained"
          size="small"
          color="primary"
          onClick={() => {
            let temp = selectedStudents;
            map(temp, s => {
              s['add_amount'] = applyAllCredits;
            });
            this.setState({ selectedStudents: temp });
          }}
        >
          {texts.button_text.apply_all}
        </Button>
      </div>
    );
  }

  renderMangeCreditsTable() {
    const { selectedStudents, texts } = this.state;
    const { classes } = this.props;
    let temp = selectedStudents;
    return (
      <div style={{ marginTop: 20 }}>
        <div className={classes.addedStudentsContainer}>
          <Typography variant="subheading">{texts.fields.name}</Typography>
          <Typography variant="subheading">{texts.fields.credits}</Typography>
        </div>
        <div className={classes.line} style={{ marginBottom: 5 }} />
        <div style={{ overflowY: 'scroll', maxHeight: 200 }}>
          {isEmpty(temp) && <Typography>No Students Selected</Typography>}
          {map(temp, student => (
            <React.Fragment>
              <div className={classes.addedStudentsContainer}>
                <Typography variant="subheading">
                  {student['Student Name']}
                </Typography>
                <Input
                  value={student['add_amount'] || 0}
                  disableUnderline
                  fullWidth
                  onChange={event => {
                    student['add_amount'] = Math.abs(event.target.value);
                    this.setState({ selectedStudents: temp });
                  }}
                  className={classes.applyAllInput}
                  style={{ border: '1px solid grey', color: 'grey' }}
                  type="number"
                />
              </div>
              <div
                style={{
                  width: '100%',
                  height: 1,
                  backgroundColor: 'grey',
                  marginBottom: 5,
                  marginTop: 5,
                }}
              />
            </React.Fragment>
          ))}
        </div>
      </div>
    );
  }

  renderMangeCreditsButtons() {
    const { classes, selectedOrganization } = this.props;
    const { program, organization } = this.props.location.state;
    const { selectedStudents, texts } = this.state;
    const temp = selectedStudents;
    let creditsToAdd = 0;
    map(selectedStudents, s => {
      if (s.add_amount) {
        creditsToAdd = creditsToAdd + parseInt(s.add_amount);
      }
    });

    const remainCredits = organization.credits - creditsToAdd * 100;
    return (
      <div className={classes.addedStudentsContainer} style={{ marginTop: 40 }}>
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => {
            map(temp, s => (s.add_amount = 0));
            this.setState({ selectedStudents: temp, applyAllCredits: 0 });
          }}
        >
          {texts.button_text.clear}
        </Button>
        <div style={{ flexDirection: 'row', display: 'flex' }}>
          <Button
            variant="contained"
            onClick={() => {
              map(temp, s => (s.add_amount = 0));
              this.setState({
                selectedStudents: temp,
                applyAllCredits: 0,
                showManageCredits: false,
              });
              this.fetchSubsidizedStudents();
              /*
              this.props.fetchStudents({
                studentSearchInput: {
                  _universities: [this.props.selectedUniversity],
                  _organizations: [this.props.selectedOrganization],
                },
              });
              */
            }}
          >
            {texts.button_text.cancel}
          </Button>
          <Button
            variant="contained"
            style={{ marginLeft: 10 }}
            disabled={remainCredits < 0}
            onClick={async () => {
              const studentsArray = map(selectedStudents, s => ({
                _student: s._id,
                amount: parseInt(s.add_amount) * 100,
              }));
              const filteredArray = await filter(
                studentsArray,
                s => s.amount > 0,
              );
              if (!isEmpty(filteredArray))
                await this.props.distributeSubsidyCredits({
                  subsidy: program._id,
                  organization: selectedOrganization,
                  students: filteredArray,
                });
              this.fetchSubsidizedStudents();
              /*
              this.props.fetchStudents({
                studentSearchInput: {
                  _universities: [this.props.selectedUniversity],
                  _organizations: [this.props.selectedOrganization],
                },
              });
              */
              this.props.fetchUser();
              this.setState({
                showManageCredits: false,
                org: { credits: remainCredits },
                applyAllCredits: 0,
              });
            }}
          >
            {texts.button_text.save}
          </Button>
        </div>
      </div>
    );
  }

  renderManageCreditsModal() {
    const { showManageCredits, selectedStudents } = this.state;
    const { classes } = this.props;
    let temp = selectedStudents;

    return (
      <Modal
        open={showManageCredits}
        onClose={() => {
          map(temp, s => (s.add_amount = 0));
          this.setState({
            showManageCredits: false,
            applyAllCredits: 0,
            selectedStudents: temp,
          });
        }}
      >
        <Card className={classes.manageCreditsModalContainer}>
          {this.renderMangeCreditsTitle()}
          {this.renderApplyAll()}
          <Typography style={{ color: 'grey', fontSize: 15, marginTop: 5 }}>
            {selectedStudents.length} students selected
          </Typography>
          {this.renderMangeCreditsTable()}
          {this.renderMangeCreditsButtons()}
        </Card>
      </Modal>
    );
  }

  renderAddStudentModal() {
    const { showAddStudentModal, texts } = this.state;
    const { classes } = this.props;
    return (
      <Modal
        open={showAddStudentModal}
        onClose={() =>
          this.setState({
            showAddStudentModal: false,
            searchAllStudent: '',
            studentsToAdd: [],
          })
        }
      >
        <Card className={classes.addStudentModalContainer}>
          <Typography
            variant="body2"
            style={{ fontWeight: '800', marginBottom: 10 }}
          >
            {texts.titles.find_student}
          </Typography>
          <div className={classes.searchContainer} style={{ width: '100%' }}>
            <Search style={{ marginRight: 5, color: '#4153af' }} />
            <Input
              value={this.state.searchAllStudent}
              disableUnderline
              fullWidth
              onChange={event =>
                this.setState({ searchAllStudent: event.target.value })
              }
              style={{ color: '#4153af' }}
            />
          </div>
          <div className={classes.line} />
          {this.renderSearchStudentsResult()}
          {this.renderAddedStudents()}
          {this.renderAddStudentModalButtons()}
        </Card>
      </Modal>
    );
  }

  renderAddedStudents() {
    const { studentsToAdd } = this.state;
    const { classes } = this.props;
    return (
      <div
        style={{
          width: '100%',
          minHeight: 100,
          overflowY: 'scroll',
          maxHeight: 150,
        }}
      >
        {map(studentsToAdd, s => (
          <div className={classes.addedStudentsContainer}>
            <div
              style={{
                flexDirection: 'row',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <AccountCircle
                color="inherit"
                fontSize="inherit"
                style={{ marginRight: 10, color: 'lightgrey', fontSize: 40 }}
              />
              <Typography>{`${s.user.first} ${s.user.last}`}</Typography>
            </div>
            <IconButton onClick={() => this.onRemoveStudent(s)}>
              <HighlightOff color="inherit" style={{ color: 'lightgrey' }} />
            </IconButton>
          </div>
        ))}
      </div>
    );
  }

  renderAddStudentModalButtons() {
    const { studentsToAdd, texts: { button_text } } = this.state;
    const { program } = this.props.location.state;

    return (
      <div style={{ justifyContent: 'flex-end', display: 'flex' }}>
        <Button
          variant="contained"
          onClick={() =>
            this.setState({
              showAddStudentModal: false,
              studentsToAdd: [],
              searchAllStudent: '',
            })
          }
        >
          {button_text.cancel}
        </Button>
        <Button
          variant="contained"
          disabled={isEmpty(studentsToAdd)}
          style={{ marginLeft: 10 }}
          onClick={async () => {
            const students = map(studentsToAdd, s => s._id);
            await this.props.addSubsidyStudents({
              subsidy: program._id,
              students,
            });
            await this.fetchSubsidizedStudents();
            /*
            await this.props.fetchStudents({
              studentSearchInput: {
                _universities: [this.props.selectedUniversity],
                _organizations: [this.props.selectedOrganization],
              },
            });
            */
            this.setState({
              showAddStudentModal: false,
              studentsToAdd: [],
              searchAllStudent: '',
            });
          }}
        >
          {button_text.simple_add}
        </Button>
      </div>
    );
  }

  renderHeaderTable() {
    const { selectedHeader, search } = this.state;
    const { program } = this.props.location.state;
    const { students } = this.props;

    const approved = filter(
      students,
      s =>
        !isEmpty(
          find(s.subsidyCredits, c => {
            if (!isEmpty(c))
              return c.subsidyId === program._id && c.status === 'approved';
            else return false;
          }),
        ),
    );
    const applied = filter(
      students,
      s =>
        !isEmpty(
          find(s.subsidyCredits, c => {
            if (!isEmpty(c))
              return c.subsidyId === program._id && c.status === 'requested';
            else return false;
          }),
        ),
    );

    const approvedData = this.reformatData(approved, 'approved');
    const appliedData = this.reformatData(applied, 'requested');

    const data = selectedHeader == 0 ? approvedData : appliedData;
    const filteredData = isEmpty(search)
      ? data
      : filter(data, d => {
          const name = toLower(d['Student Name']);
          return name.includes(toLower(search));
        });

    if (selectedHeader === 0)
      return (
        <div>
          <HeaderTable
            label="students"
            data={filteredData}
            count={approvedData.length}
            // onNext={this._onNextPage}
            // onPrev={this._onPrevPage}
            // loading={loading}
            hover={false}
            //onRowClick={p => this.props.history.push('/home/subsidy/program', { program: p })}
            // onSort={this._onSort}
            showCheckbox
            onCheckRow={d => this.onCheckRow(d)}
            onCheckAll={array => {
              this.setState({
                selectedStudents: array.slice(),
              });
            }}
            // colored={showOnlyAvailable}
          />
        </div>
      );
    else
      return (
        <HeaderTable
          label="applicants"
          data={filteredData}
          count={appliedData.length}
          // onNext={this._onNextPage}
          // onPrev={this._onPrevPage}
          // loading={loading}
          hover={false}
          //onRowClick={p => this.props.history.push('/home/subsidy/program', { program: p })}
          // onSort={this._onSort}
          sortEnabled
          showCheckbox
          onCheckRow={d => this.onCheckRow(d)}
          onCheckAll={array => {
            this.setState({
              selectedApplicants: array.slice(),
            });
          }}
          // colored={showOnlyAvailable}
        />
      );
  }

  render() {
    const { program } = this.props.location.state;
    const { classes } = this.props;
    const { texts } = this.state;

    return (
      <Paper>
        <PaperHeader text={upperFirst(program.name)} />
        <Typography className={classes.paragraph}>
          {upperFirst(program.description)}
        </Typography>
        {this.renderProgramCredits()}
        {this.renderHeader()}
        {this.renderActions()}
        {this.renderHeaderTable()}
        {this.renderAddStudentModal()}
        {this.renderManageCreditsModal()}
        {this.renderRemoveModal()}
        <Dialog
          open={this.state.openDialog}
          onClose={() => this._onCloseDialog()}
          aria-labelledby="alert"
          aria-describedby="alert"
        >
          <DialogTitle id="alert-title">{texts.titles.are_you_sure}</DialogTitle>
          <DialogActions>
            <Button onClick={() => this.continueAction()} color="primary" autofocus>
              {upperFirst(this.state.selectedAction)}
            </Button>
            <Button onClick={() => this._onCloseDialog()} color="primary" autofocus>
              {texts.button_text.cancel}
            </Button>
          </DialogActions>
        </Dialog>
      </Paper>
    );
  }
}

const styles = theme => ({
  applyAllInput: {
    color: '#4153af',
    border: '2px solid #4153af',
    borderRadius: 5,
    width: 84,
    paddingLeft: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  searchStudentContainer: {
    backgroundColor: 'lightgrey',
    overflowY: 'scroll',
    maxHeight: 100,
    position: 'absolute',
    alignSelf: 'center',
    zIndex: 100,
    width: 350,
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
  },
  addedStudentsContainer: {
    flexDirection: 'row',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  manageCreditsModalContainer: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    width: 573,
    transform: 'translate(-50%, -50%)',
    overflow: 'auto',
    padding: theme.spacing.unit * 3,
  },
  addStudentModalContainer: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    width: 398,
    transform: 'translate(-50%, -50%)',
    overflow: 'auto',
    padding: theme.spacing.unit * 3,
  },
  actionContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    paddingLeft: theme.spacing.unit * 3,
    paddingRight: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 3,
    display: 'flex',
  },
  searchContainer: {
    borderRadius: 42,
    width: 340,
    paddingRight: theme.spacing.unit * 2,
    paddingLeft: theme.spacing.unit * 2,
    alignItems: 'center',
    justifyContent: 'flex-start',
    border: '2px solid #4153af',
    flexDirection: 'row',
    display: 'flex',
  },
  tabsRoot: {
    marginBottom: theme.spacing.unit * 5,
    marginLeft: theme.spacing.unit * 4,
  },
  tabsIndicator: {
    backgroundColor: '#4153af',
  },
  tabText: {
    fontSize: 18,
    fontWeight: theme.typography.fontWeightBold,
  },
  tabRoot: {
    textTransform: 'initial',
    minWidth: 72,
    marginRight: theme.spacing.unit * 4,
    '&:hover': {
      color: 'grey',
      opacity: 1,
    },
    '&$tabSelected': {
      color: '#4153af',
    },
    '&:focus': {
      color: '#4153af',
    },
  },
  tabSelected: {},
  headerButton: {
    marginRight: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 5,
    marginTop: theme.spacing.unit * 3,
  },
  paragraph: {
    marginBottom: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit * 3,
  },
  green: {
    color: '#17C289',
  },
  line: {
    width: '100%',
    backgroundColor: 'black',
    height: 1,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
  border: {
    border: '30px solid grey',
    borderRadius: 4,
    borderWidth: 1,
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
  dashedBorder: {
    border: '30px dashed grey',
    borderRadius: 4,
    borderWidth: 1,
    alignItems: 'center',
    padding: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
    justifyContent: 'center',
    width: '100%',
    height: 200,
    flexDirection: 'column',
  },
  marginHorizontal: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  gridContainer: {
    paddingLeft: theme.spacing.unit * 3,
    paddingBottom: theme.spacing.unit * 2,
    paddingRight: theme.spacing.unit * 3,
  },
  padding: {
    paddingRight: theme.spacing.unit,
  },
  confirmRemoveModal: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    width: theme.spacing.unit * 55,
    transform: 'translate(-50%, -50%)',
    overflow: 'auto',
    padding: theme.spacing.unit * 3,
  },
});

export default compose(
  withStyles(styles, { name: 'Program' }),
  connect(
    state => ({
      selectedUniversity: state.auth.selectedUniversity,
      selectedOrganization: state.auth.selectedOrganization,
      students: state.students.main.data,
      organizations: get(state, 'auth.data.user.organizations'),
      selectedOrganization: get(state, 'auth.selectedOrganization'),
      locale: state.appState.locale,
    }),
    dispatch => ({
      fetchStudents: params => dispatch(fetchStudents(params)()),
      fetchSubsidizedStudents: params =>
        dispatch(fetchSubsidizedStudents(params)()),
      addSubsidyStudents: params => dispatch(addSubsidyStudents(params)()),
      removeSubsidyStudents: params =>
        dispatch(removeSubsidyStudents(params)()),
      distributeSubsidyCredits: params =>
        dispatch(distributeSubsidyCredits(params)()),
      studentSubsidyApprove: params =>
        dispatch(studentSubsidyApprove(params)()),
      studentSubsidyReject: params => dispatch(studentSubsidyReject(params)()),
      fetchUser: () => dispatch(fetchUser()()),
    }),
  ),
)(Program);



// WEBPACK FOOTER //
// ./src/modules/program/Scene.js